var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"70px"}},[_c('Filters'),_c('TabNavigation'),_c('div',[_c('day-detail',{attrs:{"title":'Planificación del día',"anchor":'anchor',"day":_vm.currentSelectedDate}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }